import React, {Component} from 'react';

import {Row, Col, Card, CardImg, CardTitle} from 'reactstrap';
import Swiper from 'react-id-swiper';
import StarRatingComponent from 'react-star-rating-component';
import { connect } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { isGamiclub } from '../../constants/isGamiclub';
import { isGameflares, isGamiway } from '../../constants/productCondition';
const kazakhDomain = (config.lang == 'kk') ? true : false;

class CategoryGames extends Component {
    constructor(props) {
        super(props);
        this.shuffle = this.shuffle.bind(this);
        this.applyHuaRule = this.applyHuaRule.bind(this);
        this.applyTRRule = this.applyTRRule.bind(this);
        this.arrayMove = this.arrayMove.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }
    
    shuffle(gameArray) {
        if((config.subDomain == 'hua'|| config.subDomain == 'gmn') && gameArray[0].categoryId == 18){
            return this.applyHuaRule(gameArray);
        }
        if (config.subDomain == 'tr' && (gameArray[0].categoryId == 18 || gameArray[0].categoryId == 23)){
            return this.applyTRRule(gameArray, gameArray[0].categoryId);
        } 
        var shuffledArray = gameArray.sort(() => Math.random() - 0.5);
        return shuffledArray;
    }
    applyHuaRule(gameArray){
        const gameIdsToBeFirst = [124, 434, 435];
        let result=[];
        for(let i=0; i<gameArray.length; i++){
            if (gameArray[i].gameId == gameIdsToBeFirst[0] || gameArray[i].gameId == gameIdsToBeFirst[1] || gameArray[i].gameId == gameIdsToBeFirst[2]){
                result = this.arrayMove(gameArray, i, 0);
            }
        }
        return result;
    }

    applyTRRule(gameArray, categoryId){
        let gameIdsToBeFirst = [];
        if(categoryId == 18) gameIdsToBeFirst = [436];
        else if(categoryId == 23) gameIdsToBeFirst = [455];
        // const gameIdsToBeFirst = [436];
        let result = [];
        for (let i = 0; i < gameArray.length; i++) {
            if (gameArray[i].gameId == gameIdsToBeFirst[0]) {
                result = this.arrayMove(gameArray, i, 0);
            }
        }
        return result;

    }

    arrayMove(arr, oldIndex, newIndex) {
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        return arr;
    }
    
    render() {
        const {category}=this.props;
        let englishCat = ["Premium Games", "Action", "Adventure", "RPG", "Virtual Reality", "Arcade", "Racing", "Sports"];
        const gamesParams = {
            direction: 'horizontal',
            slidesPerView: 'auto',
            speed: 500,
        }

        var gameRelatedMoreClass = "game-related-more";
        var gameCategoryTitleClass = "game-category-title";
        if(kazakhDomain){
            gameRelatedMoreClass += ' kz-related-more';
            gameCategoryTitleClass+= ' kz-text';
        } 
        return (
            <div >
                <Row >
                    <Col xs="12" className="game-related-container">
                        <div className="game-related-top">
                            <div className="game-category" style={isGamiclub ? {borderBottom: '1px solid green'} : isGameflares ? {borderBottom: '1px solid #FF394B'}: isGamiway ? {borderBottom: '1px solid #b347a0'} :  null}>
                                <h2 style={isGamiclub ? {color: 'white', backgroundColor: 'green'} : isGameflares ? {color: 'white', backgroundColor: '#FF394B'}: isGamiway ? {color:'white', backgroundColor:'#b347a0'}: null} className={gameCategoryTitleClass}><i className={this.props.category.categoryIcon} aria-hidden="true"></i>
                                <FormattedMessage id={`${category.categoryName}`}
                                        defaultMessage={category.categoryName}
                                    />
                                </h2>
                                <a className={gameRelatedMoreClass} style={isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'} :null} href={"/#/category/" + this.props.category.categoryId + "?uid=" + this.props.access.uid}>
                                    <FormattedMessage id="viewAll"
                                        defaultMessage="View All"
                                    />
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="game-list-row">
                    {(this.props.games.length > 0) ?
                        <Col xs="12">
                            <Swiper {...gamesParams} shouldSwiperUpdate={true}>
                                {this.shuffle(this.props.games).map((game) => {
                                    console.log(game.gameTitle.toUpperCase())
                                    return (
                                        <div className="swiper-game-card" key={game.gameId}>
                                            <Card className={isGamiclub ? "game-card-gamiclub" : isGameflares ? "game-card gameflares-card-hover": isGamiway ? "game-card gamiway-card": "game-card"} onClick={this.props.onFavoriteClick.bind(this,game)}>
                                                <div className="game-card-inner">
                                                    <div className="game-thumb-wrap">
                                                        <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle}/>
                                                    </div>
                                                    <div className="game-card-details">
                                                        {config.subDomain != 'es' && <CardTitle className="game-title text-shadow">
                                                        <FormattedMessage id={`${game.gameTitle.toUpperCase()}`}
                                                         defaultMessage={game.gameTitle}/>
                                                           </CardTitle>}
                                                        {window.location.hostname.includes('vplay') ? null :    
                                                        <div className="custom-rating isFavorite">
                                                            <input id={'fav'+game.gameId} ref={'star'+game.gameId} className="" type="checkbox" checked={game.isFavorite}/>
                                                            <label htmlFor={'fav'+game.gameId} className="isFavorite">
                                                                <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'}: null} className="fa fa-star-o custom-star isFavorite"></i>
                                                            </label>
                                                        </div>
                                                        }
                                                        <div className="game-card-left">
                                                            <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'} :isGamiway ? {color:'#b347a0'} : null} className="fa fa-star custom-star"></i>}/>
                                                        </div>
                                                        {(!window.location.hostname.includes('vplay') && config.subDomain != 'es') && 
                                                        <div className="game-card-right text-uppercase text-shadow text-right">{(game.gameType.toLowerCase() === "html5") ? <i className="fa fa-html5" aria-hidden="true"></i> : (game.gameType.toLowerCase() === "android") ? <i className="fa fa-android" aria-hidden="true"></i> : <i className="fa fa-video-camera" aria-hidden="true"></i>}</div>}
                                                        
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                    )
                                })}
                            </Swiper>
                        </Col>
                        : <Col xl="12" lg="12" md="12" sm="12" xs="12"> <p className="white-text-color">
                             {window.location.hash.includes('home/video') ? <FormattedMessage id="noVideosFound" defaultMessage="No videos found under this category." /> 
                            : <FormattedMessage id="noGamesFound" defaultMessage="No games found under this category." />}
                        </p></Col>
                    }
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    access: state.WelcomeReducer
    };
};


export default connect(mapStateToProps)(CategoryGames);



// WEBPACK FOOTER //
// ./src/components/CategoryGames/CategoryGames.js